<template>
<div class="header header_verify">
    <div class="layout-ceiling">
        <div class="layout-ceiling-main">
            <a href="javascript:;">{{userInfo.username}}</a>
            <a  @click="logout" > |退出</a>
        </div>
    </div>
    <div class="layout-logo">
        <!-- <img :src="logoSrc" alt=""> -->
    </div>
    <h1 class="title">供应核销系统</h1>
</div>
</template>
<script>
import config from '../config/config.js';
import COOKIE from '../api/cookie.js';
import {httpGet, httpPost,loginHttpPost} from '../api/base';
import jsonp from 'jsonp'
import {mapState,mapMutations,mapGetters,mapActions} from 'vuex'
export default {
    data(){
        return{
            shopDomain: config.shop_api_domain,
            userName:'',
            path:config.path,
            logo:config.project_name,
            base_url_path: config.base_url_path,
        }
    },
    props:[],
    components:{
        
    },
    watch:{
       
    },
    computed:{
        ...mapGetters([
            'userInfo',
            //合作协议
            // 'agree'
        ]),
        logoSrc(){
            if(this.logo == 'neigou' && this.userInfo && (this.userInfo.shop_id == 42 || this.userInfo.shop_id ==24105)){
                return this.base_url_path+'static/shop/images/'+this.logo+'/yongbin-shop.logo.png'
            }else{
                return this.base_url_path+'static/shop/images/'+this.logo+'/logo.png?v=1619352332'
            }
        },
    },
    mounted(){
        let Vm=this;
        
        this.$store.dispatch('getUserInfo');
    },
    created(){
        let Vm=this;
        
    },
    methods:{
        isChangePassword(){
            return ['changePassword'].indexOf(this.$route.name)>=0;
        },
        isAdd(){
            return ['activityAdd'].indexOf(this.$route.name)>=0;
        },
        logout(){
            let Vm=this;
             httpPost(this.shopDomain+'Shop/Member/logout',{}).then((res)=>{
                if(res.data.errno==0){
                    setTimeout(()=>{
                        this.$Message.success(res.data.error);
                        window.location.href=config.verifyFallbackPath+'login.html'
                    },300)
                }else{
                    this.$Message.error(res.data.error);
                }
            })
        }
    },
    
}
</script>
<style lang="scss">
    div.header_verify{
        h1.title{
            padding-left: 0;
        }
        .layout-logo{
            border-right: 0;
        }
    }
</style>